import { useDisplayedFilters, type DisplayedFilter } from "hooks/use-displayed-filters";
import type { ComponentType } from "react";

type WithDisplayedFiltersProps = {
  displayedFilters: DisplayedFilter[];
  displayedFilterCount: number;
};

export function withDisplayedFilters<P extends object>(Component: ComponentType<P & WithDisplayedFiltersProps>) {
  const WrappedComponent: ComponentType<P> = (props: P) => {
    const { displayedFilters, displayedFilterCount } = useDisplayedFilters();

    /* eslint-disable-next-line react/jsx-props-no-spreading */
    return <Component {...props} displayedFilters={displayedFilters} displayedFilterCount={displayedFilterCount} />;
  };

  return WrappedComponent;
}
